const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/e07338050c4a329098f92b619102fe32.jpg"
          alt="Professional Financial Planning"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B3A5F]/70 via-[#1B3A5F]/60 to-[#1B3A5F]/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-gilroy text-white mb-6 leading-tight">
          Comprehensive Financial Planning<br />
          <span className="text-[#F5A623]">& Wealth Management</span>
        </h1>
        <p className="text-lg sm:text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Expert guidance to help you achieve your financial goals and secure your future. Personalised strategies for individuals and businesses.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-[#F5A623] text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-[#E09612] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Schedule Consultation
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('services');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-white/20 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
          >
            Our Services
          </button>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 bg-[#F5A623] rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Trusted Expertise</h3>
            <p className="text-white/80 text-sm">Professional guidance you can rely on</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 bg-[#F5A623] rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-heart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Personalised Plans</h3>
            <p className="text-white/80 text-sm">Tailored strategies for your goals</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 bg-[#F5A623] rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-line-chart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Proven Results</h3>
            <p className="text-white/80 text-sm">Track record of success</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => {
            const element = document.getElementById('services');
            if (element) {
              const offset = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;
              window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
            }
          }}
          className="text-white/80 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
};

export default Hero;
